import React from "react";
import QRCode from "./QRCode";

import "./QRCodeGenerator.css";

import PlantImage from "../../Sprite/PlantImage";

const buildPlantUrl = (plant) => {
  const params = new URLSearchParams();
  if (plant.campaign) params.set("campaign", plant.campaign);
  if (plant.printJobId) params.set("printJob", plant.printJobId);
  if (plant.plantType || plant.plant?.species) {
    params.set("species", plant.plantType || plant.plant?.species);
  }
  const query = params.toString();
  return `https://reallifeplants.com/plant/${plant.plantID}${query ? `?${query}` : ""}`;
};

const GridItem = (props) => {
  const { plant, template } = props;
  const scientificName =
    plant?.plant?.species ||
    plant?.plantType ||
    plant?.species?.scientificName ||
    "";
  const commonName = plant?.species?.commonName || scientificName;

  if (plant?.isPlaceholder) {
    return (
      <div
        className="grid-item"
        style={{
          height: template.gridItemHeight,
          width: template.gridItemWidth,
          margin: template.gridItemMargin,
          padding: template.gridItemPadding,
          backgroundColor: "white",
        }}
      />
    );
  }

  return (
    <div
      className="grid-item"
      style={{
        height: template.gridItemHeight,
        width: template.gridItemWidth,

        margin: template.gridItemMargin,
        padding: template.gridItemPadding,
        textAlign: template.gridItemAlignment,

        backgroundColor: "white",
        //backgroundColor: "rgb(255, 240, 207)",

        /*borderColor: "black",
        borderStyle: "solid",
        borderWidth: "2px",*/
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          backgroundColor: "white",

          //backgroundColor: "rgb(255, 240, 207)",
          paddingBottom: "2px",
        }}
      >
        <div className="nameAndCodes">
          <div>
            <div className="helloMyNameIsText">hi! my name is:</div>
          </div>
          <div>
            <QRCode
              url={buildPlantUrl(plant)}
              backgroundColor={"#ffffff"}
              foregroundColor={plant.color}
              template={template}
            />
            <div
              style={{
                fontSize: "6px",
                textAlign: "center",
                paddingBottom: "0px",
              }}
            >
              {plant.secretCode}
            </div>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: "1" }}>
          <div style={{ height: "110px", zIndex: "1", marginRight: "-20px" }}>
            {plant.plant && plant.species ? (
              <PlantImage
                plant={plant.plant}
                species={plant.species}
                width={"60%"}
              />
            ) : null}
            <div
              style={{
                textAlign: "center",
                fontSize: "6px",
                opacity: "100%",
              }}
            >
              <em>{commonName}</em>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridItem;
